// SMART DEMO — Nova Clean Premium asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 home-cleaning + 4 post-construction + 4 sofa-cleaning + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Nova Clean Premium" tamamen kurgu demo markadır.

export const NOVA_CLEAN_ASSET_ROOT = "/demo-presets/cleaning/nova-clean";

export interface NovaCleanManifest {
  logo: string;
  homeCleaning: string[];
  postConstruction: string[];
  sofaCleaning: string[];
  videos: string[];
}

export const NOVA_CLEAN_MANIFEST: NovaCleanManifest = {
  logo: `${NOVA_CLEAN_ASSET_ROOT}/logo/logo.webp`,
  homeCleaning: [
    `${NOVA_CLEAN_ASSET_ROOT}/home-cleaning/01.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/home-cleaning/02.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/home-cleaning/03.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/home-cleaning/04.webp`,
  ],
  postConstruction: [
    `${NOVA_CLEAN_ASSET_ROOT}/post-construction/01.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/post-construction/02.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/post-construction/03.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/post-construction/04.webp`,
  ],
  sofaCleaning: [
    `${NOVA_CLEAN_ASSET_ROOT}/sofa-cleaning/01.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/sofa-cleaning/02.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/sofa-cleaning/03.webp`,
    `${NOVA_CLEAN_ASSET_ROOT}/sofa-cleaning/04.webp`,
  ],
  videos: [
    `${NOVA_CLEAN_ASSET_ROOT}/videos/01.mp4`,
    `${NOVA_CLEAN_ASSET_ROOT}/videos/02.mp4`,
  ],
};